import { useMutation } from "@tanstack/react-query";
import { client } from "@augmodo/lebron-browser-client";

/**
 * Partial-update a JobTask's metadata (merge) via PATCH /v1/job-tasks/{id}.
 * Used so a labeler can mark a QA task about their own work as reviewed
 * (metadata.labeler_reviewed = true) without disturbing its result/status.
 *
 * Uses the raw client (like useCompleteJobTask) so it works without
 * regenerating the typed SDK.
 */
export function useUpdateJobTaskMetadata(taskId: string) {
  return useMutation({
    mutationFn: async (metadata: Record<string, unknown>) => {
      const response = await client.patch({
        url: `/v1/job-tasks/${taskId}`,
        body: { metadata },
      });

      if (response.error) {
        throw new Error(
          `Failed to update job task metadata: ${response.error}`,
        );
      }

      return response.data;
    },
    onError: (error) => {
      console.error("Update job task metadata failed:", error);
    },
  });
}
